import React from "react";
import { Link } from "react-router";
import { useScopeParams } from "@/hooks/useScopeParams";

interface Card {
  type: string;
  title: string;
  description: string;
  meta: string;
  href?: string;
}

interface TryNextProps {
  heading?: string;
  cards: Card[];
}

export const TryNext: React.FC<TryNextProps> = ({
  heading = "Try this next",
  cards,
}) => {
  const { buildUrl } = useScopeParams();

  return (
    <>
      <div className="trynext__head">{heading}</div>
      <div className="trynext">
        {cards.map((c, i) => {
          const path = c.href?.replace(/^#?\/?/, "") || "";
          const to = path ? buildUrl(path) : "#";

          return (
            <Link key={i} to={to} className="trynext__card">
              <div className="trynext__type">{c.type}</div>
              <h4 className="trynext__title">{c.title}</h4>
              {c.description && (
                <p className="trynext__desc">{c.description}</p>
              )}
              <div className="trynext__meta">{c.meta}</div>
            </Link>
          );
        })}
      </div>
    </>
  );
};
